import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { showNotification as showNotificationAction, refreshView as refreshViewAction } from 'admin-on-rest';
import restClient from '../restClient';

// Default "blacklist clicks from" date: start of the current month. Previous months are
// already invoiced, so a bulk import should never silently reach back into one.
// Plain YYYY-MM-DD (native <input type="date">, not MUI's DatePicker) - a DatePicker's popup
// calendar can render behind an enclosing Dialog due to a z-index stacking conflict, making it
// unusable. See https://github.com/mui/mui-x/issues/10035 for the same class of issue.
const defaultFromDate = () => {
    const now = new Date();
    return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}-01`;
};

class BulkBlacklistIpsButton extends Component {
    state = { dialogOpen: false, loading: false, ipaddresses: '', label: '', removeclicks_from: defaultFromDate() };

    openDialog = () => this.setState({ dialogOpen: true });
    closeDialog = () => this.setState({ dialogOpen: false });

    handleSubmit = () => {
        const { showNotification, refreshView } = this.props;
        const { ipaddresses, label, removeclicks_from } = this.state;

        if (!ipaddresses.trim()) {
            showNotification('Plak eerst één of meer IP-adressen', 'warning');
            return;
        }

        this.setState({ loading: true });

        restClient('POST', 'admin/ipblacklist_bulk', {
            data: {
                ipaddresses,
                label: label || undefined,
                removeclicks_from: removeclicks_from || undefined,
            },
        })
            .then(({ data }) => {
                showNotification(`${data.created} IP('s) toegevoegd, ${data.skipped} overgeslagen (al aanwezig of ongeldig)`, 'confirm');
                this.setState({ loading: false, dialogOpen: false, ipaddresses: '', label: '', removeclicks_from: defaultFromDate() });
                refreshView();
            })
            .catch((e) => {
                console.error(e);
                const message = (e && e.message) || 'Bulk-import mislukt, probeer het opnieuw';
                showNotification(message, 'warning');
                this.setState({ loading: false });
            });
    };

    render() {
        const { dialogOpen, loading, ipaddresses, label, removeclicks_from } = this.state;

        const actions = [
            <FlatButton label="Annuleer" onClick={this.closeDialog} disabled={loading} />,
            <RaisedButton
                label={loading ? 'Bezig...' : 'Blacklisten'}
                primary
                style={{ marginLeft: 8 }}
                onClick={this.handleSubmit}
                disabled={loading}
            />,
        ];

        return (
            <span>
                <FlatButton label="Bulk toevoegen" onClick={this.openDialog} />
                <Dialog
                    title="Meerdere IP's tegelijk blacklisten"
                    modal={false}
                    open={dialogOpen}
                    onRequestClose={this.closeDialog}
                    actions={actions}
                    autoScrollBodyContent
                >
                    <p>
                        Eén IP-adres per regel (of gescheiden door komma's). Elk IP wordt 6 maanden
                        geblacklist en kliks vanaf hieronder gekozen datum worden voor dat IP alsnog
                        als ongeldig gemarkeerd. Kies nooit een datum in een al gefactureerde maand —
                        standaard staat dit op de 1e van deze maand.
                    </p>
                    <TextField
                        floatingLabelText="IP-adressen"
                        hintText={'83.99.206.182\n217.113.194.228\n...'}
                        multiLine
                        rows={6}
                        fullWidth
                        value={ipaddresses}
                        onChange={(_e, v) => this.setState({ ipaddresses: v })}
                    />
                    <TextField
                        floatingLabelText="Label (optioneel)"
                        hintText="Bijv. 'Analyse juli 2026'"
                        fullWidth
                        value={label}
                        onChange={(_e, v) => this.setState({ label: v })}
                    />
                    <br />
                    <TextField
                        type="date"
                        floatingLabelText="Kliks blacklisten vanaf"
                        fullWidth
                        value={removeclicks_from}
                        onChange={(_e, v) => this.setState({ removeclicks_from: v })}
                    />
                </Dialog>
            </span>
        );
    }
}

export default connect(null, {
    showNotification: showNotificationAction,
    refreshView: refreshViewAction,
})(BulkBlacklistIpsButton);



// WEBPACK FOOTER //
// ./src/siteclicks/BulkBlacklistIpsButton.js